import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	edit__phones__list: 'mw/user/edit/phones/list',
};

export const userApi = createApi({
	reducerPath: 'mw/userApi',

	endpoints: (builder) => ({
		editPhonesList: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/user/edit/phones/list',
				body,
				jsonType: true,
			}),
			providesTags: [tags.edit__phones__list],
		}),
	}),
});

export const {
	editPhonesList,
} = userApi.endpoints;

export default userApi;